import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { Avatar, Box, Button, CssBaseline, Grid, IconButton, InputAdornment, Link, Menu, MenuItem, Paper, Stack, Tab, Tabs, TextField, Typography, FormControl, Select, useMediaQuery, useTheme } from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import "animate.css/animate.css";
import { Form, Formik } from 'formik';
import * as React from 'react';
import { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import WOW from "wowjs";
import * as Yup from 'yup';
import { apiURL, GetAll, Post } from "../../utils/apiCalls";
import CircularProgress from '@mui/material/CircularProgress';
import OtpInput from 'react-otp-input';

const defaultTheme = createTheme();
const rnd = ["sections/home-top-background.jpg", "hand.jpg", "home1.jpg", "area.png"]
const rnd_no = Math.floor(Math.random() * rnd.length)

const AdminSchema = Yup.object({
  login_id: Yup.string().required('Email id / Mobile No. is required'),
  password: Yup.string().required('Password is required'),
});

const AgentSchema = Yup.object({
  login_id: Yup.string().required('Email id / Mobile No. is required'),
  password: Yup.string().required('M-Pin is required').matches(/^[0-9]{4}$/, 'Invalid M-Pin'),
});

const ProcurementLoginSchema = Yup.object({
  login_id: Yup.string().required('Email id / Mobile No. is required'),
  password: Yup.string().required('M-Pin is required').matches(/^[0-9]{4}$/, 'Invalid M-Pin'),
});

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ px: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function LoginPage() {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [value, setValue] = useState(0);
  const [showPassword, setShowPassword] = useState({ 'reenter_password': false, 'password': false });
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [roles, setRoles] = React.useState([]);
  const [ loader ,setLoader] = useState(false)

  const loginTypes = [
    { label: 'Admin', value: 0 },
    { label: 'Procurement(Partner)', value: 1 },
    { label: 'Developer', value: 2 },
    { label: 'Associate', value: 3 }
  ];

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const getRoles = useCallback(async () => {
    const response = await GetAll(apiURL + '/api/v1/users/admin_roles', navigate)
    if (response && response.data && response.data.status) {
      setRoles(response.data)
    }
    else {
      toast.error(response?.data?.message || 'Please Try Again')
    }
  }, [navigate])

  useEffect(() => {
    sessionStorage.removeItem('otpVerify')
    const wow = new WOW.WOW({
      live: false,
    });
    wow.init();
    getRoles()
  },[getRoles]);

  const handleAgentLogin = async (values, { setSubmitting }) => {
    setLoader(true)
    const response = await Post(apiURL + '/api/v1/users/agent/login', { ...values }, navigate)
    if (response && response.data && response.data.status) {
      setLoader(false)
      toast.success('Login Successful')
      setSubmitting(false)
      sessionStorage.setItem('token', response.data.data['token'])
      sessionStorage.setItem('user_details', JSON.stringify(response.data.data['data']))
      if(response.data.data.data.subscribe){
        navigate("/dashboard/projectagent");
      }else{
        navigate("/dashboard/subscribe");
  }    }
    else {
      setLoader(false)
      toast.error(response?.data?.message || 'Please Try Again')
      setSubmitting(false)
    }
  };

  const handleAdminLogin = async (values, { setSubmitting }) => {
    setLoader(true)
    const response = await Post(apiURL + '/api/v1/users/admin/login', { ...values,"role":value }, navigate)
    if (response && response.data && response.data.status) {
      setLoader(false)
      toast.success('Login Successful')
      setSubmitting(false)
      sessionStorage.setItem('token', response.data.data['token'])
      sessionStorage.setItem('user_details', JSON.stringify(response.data.data['data']))
      navigate("/dashboard/projectAdmin");
    }
    else {
      setLoader(false)
      toast.error(response?.data?.message || 'Please Try Again')
      setSubmitting(false)
    }
  }

  const handleProcurementLogin = async (values, { setSubmitting }) => {
    setLoader(true)
    const response = await Post(apiURL + '/api/v1/procurement-admin-users/login', { ...values ,procurement:true}, navigate)
    if (response && response.data && response.data.status) {
      setLoader(false)
      toast.success('Login Successful')
      setSubmitting(false)
      sessionStorage.setItem('token', response.data.data['token'])
      sessionStorage.setItem('user_details', JSON.stringify(response.data.data['data']))
      console.log(response.data.data.data.subscribe,"response.data.data.data.subscribe")

        if(response.data.data.data.subscribe){
          navigate("/dashboard/procurement-dashboard");
        }else{
          navigate("/dashboard/procurement-subscribe");
        }
    }
    else {
      setLoader(false)
      toast.error(response?.data?.message || 'Please Try Again')
      setSubmitting(false)
    }
  }

  const handleClickShowPassword = (val) => setShowPassword((prev) => ({ ...prev, [val]: !showPassword[val] }));
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleLoginOtp = async (type, data) => {
    if (data.login_id) {
      sessionStorage.setItem('otpVerify', JSON.stringify({ type: type, EmailorMobile: data.login_id }))
      const response = await Post(apiURL + '/api/v1/users/login_otp', { login_id: data.login_id }, navigate)
      if (response && response.data && response.data.status) {
        toast.success("OTP Sent succcessfully")
        navigate('/otp-verify')
      }
      else {
        toast.error(response?.data?.message || 'Please Try Again')
      }
    }
    else toast.error('Please Enter Valid Email/Mobile')
  }


  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <ThemeProvider theme={defaultTheme}>

      <Grid container component="main" sx={{ height: "100vh" }}>
        <CssBaseline />
        {!isMobile && (
        <Grid item xs={false} sm={4} md={7}
          sx={{
              backgroundImage: `url(${require(`../../img/${rnd[rnd_no]}`)})`,
            backgroundRepeat: "no-repeat",
            backgroundColor: (t) =>
              t.palette.mode === "light"
                ? t.palette.grey[50]
                : t.palette.grey[900],
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        />
        )}
        <Grid item xs={12} sm={8} md={5} component={Paper} elevation={isMobile ? 0 : 6} square>
          <Box sx={{ 
            my: isMobile ? 2 : 6, 
            mx: isMobile ? 2 : 4, 
            display: "flex", 
            flexDirection: "column", 
            alignItems: "center",
            minHeight: isMobile ? '100vh' : 'auto',
            justifyContent: isMobile ? 'center' : 'flex-start'
          }}>
            <Avatar sx={{ 
              m: isMobile ? 0.5 : 1, 
              bgcolor: "secondary.main",
              width: isMobile ? 48 : 56,
              height: isMobile ? 48 : 56
            }}>
              <LockOutlinedIcon sx={{ fontSize: isMobile ? 24 : 28 }} />
            </Avatar>
            <Typography component="h1" variant={isMobile ? "h6" : "h5"} sx={{ fontWeight: 600, mb: isMobile ? 0.5 : 1 }}>
              SIGN IN
            </Typography>

            <Box>
              {/* Mobile Dropdown */}
              {isMobile ? (
                <FormControl fullWidth sx={{ mb: 2, mt: 2 }}>
                  <Select
                    value={value}
                    onChange={(e) => setValue(e.target.value)}
                    displayEmpty
                    variant="outlined"
                    size="small"
                    sx={{ 
                      '& .MuiSelect-select': {
                        display: 'flex',
                        alignItems: 'center',
                        fontSize: '16px',
                        fontWeight: 500,
                        padding: '12px 14px'
                      },
                      '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#c4c4c4'
                      },
                      '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#1976d2'
                      },
                      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#1976d2',
                        borderWidth: '2px'
                      }
                    }}
                  >
                    {loginTypes.map((type) => (
                      <MenuItem key={type.value} value={type.value}>
                        <Typography variant="body1" sx={{ fontWeight: 500 }}>
                          {type.label}
                        </Typography>
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              ) : (
                /* Desktop Tabs */
                <Tabs 
                  value={value} 
                  onChange={handleChange} 
                  aria-label="login type tabs"
                  variant="fullWidth"
                  sx={{
                    '& .MuiTab-root': {
                      fontSize: '14px',
                      fontWeight: 500,
                      minHeight: 48,
                      textTransform: 'none',
                      '&.Mui-selected': {
                        color: theme.palette.primary.main,
                        fontWeight: 600
                      }
                    },
                    '& .MuiTabs-indicator': {
                      backgroundColor: theme.palette.primary.main,
                      height: 3
                    }
                  }}
                >
                  <Tab label="Admin" {...a11yProps(0)} />
                  <Tab label="Procurement" {...a11yProps(1)} />
                  <Tab label="Developer" {...a11yProps(2)} />
                  <Tab label="Associate" {...a11yProps(3)} />
              </Tabs>
              )}
          <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose} PaperProps={{ sx: { width: 180, }, }}>
               { roles?.data?.map((item, index) => (<MenuItem key={index} onClick={handleClose}>{item.designation}</MenuItem>))}
              </Menu>
              <CustomTabPanel value={value} index={0}>
                
                  <Box sx={{ mt: 1 }}>
                    <Formik validationSchema={AdminSchema} onSubmit={handleAdminLogin}
                      initialValues={{ login_id: sessionStorage.getItem('otpVerify') ? JSON.parse(sessionStorage.getItem('otpVerify')).type === 'admin' ? JSON.parse(sessionStorage.getItem('otpVerify')).login_id : '' : '', password: "" }} enableReinitialize={true}>
                      {({ handleSubmit, handleChange, values, errors, getFieldProps, touched }) => (
                        <Form onSubmit={handleSubmit}>
                          <TextField 
                            margin="normal"
                            placeholder="Email Id / Mobile No."
                            fullWidth
                            variant="outlined"
                            size={isMobile ? "small" : "medium"}
                            {...getFieldProps('login_id')}
                            error={touched?.login_id && Boolean(errors?.login_id)}
                            helperText={touched?.login_id && errors?.login_id}
                            sx={{
                              '& .MuiInputBase-input': {
                                fontSize: isMobile ? '16px' : '14px',
                                padding: isMobile ? '12px 14px' : '16px 14px'
                              },
                              '& .MuiOutlinedInput-notchedOutline': {
                                borderColor: '#c4c4c4'
                              },
                              '&:hover .MuiOutlinedInput-notchedOutline': {
                                borderColor: '#1976d2'
                              },
                              '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                borderColor: '#1976d2',
                                borderWidth: '2px'
                              }
                            }}
                          />

                          <TextField 
                            margin="normal"
                            type={showPassword['password'] ? 'text' : 'password'}
                            placeholder="Password"
                            fullWidth
                            variant="outlined"
                            size={isMobile ? "small" : "medium"}
                            {...getFieldProps('password')}
                            error={touched?.password && Boolean(errors?.password)}
                            helperText={touched?.password && errors?.password}
                            sx={{
                              '& .MuiInputBase-input': {
                                fontSize: isMobile ? '16px' : '14px',
                                padding: isMobile ? '12px 14px' : '16px 14px'
                              },
                              '& .MuiOutlinedInput-notchedOutline': {
                                borderColor: '#c4c4c4'
                              },
                              '&:hover .MuiOutlinedInput-notchedOutline': {
                                borderColor: '#1976d2'
                              },
                              '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                borderColor: '#1976d2',
                                borderWidth: '2px'
                              }
                            }}
                            InputProps={{
                              endAdornment:
                                <InputAdornment position="end">
                                  <IconButton
                                    aria-label="toggle password visibility"
                                    onClick={() => handleClickShowPassword('password')}
                                    onMouseDown={handleMouseDownPassword}
                                    edge="end"
                                    size={isMobile ? "small" : "medium"}
                                  >
                                    {showPassword['password'] ? <VisibilityOff /> : <Visibility />}
                                  </IconButton>
                                </InputAdornment>
                            }}
                          />

                          <Stack spacing={1} sx={{ mt: 2 }}>
                            <Button 
                              type="submit" 
                              fullWidth 
                              variant="contained" 
                              size={isMobile ? "large" : "medium"}
                              sx={{ 
                                mt: 3, 
                                mb: 2,
                                py: isMobile ? 1.5 : 1,
                                fontSize: isMobile ? '16px' : '14px',
                                fontWeight: 600,
                                textTransform: 'none'
                              }}
                            >
                              {loader ? (
                                <Box sx={{ display: 'flex' }}>
                                  <CircularProgress size={isMobile ? 28 : 25} color="inherit" />
    </Box>
                              ) : (
                                'SIGN IN AS ADMIN'
                              )}
                            </Button>
                          </Stack>
                        </Form>
                      )}
                    </Formik>
                  </Box>
              

              </CustomTabPanel>
              <CustomTabPanel value={value} index={1}>
                
                <Box sx={{ mt: 1 }}>
                  <Formik validationSchema={ProcurementLoginSchema} onSubmit={handleProcurementLogin}
                    initialValues={{ login_id: '', password: "" }} enableReinitialize={true}>
                    {({ handleSubmit, handleChange, values, errors, getFieldProps, touched, setFieldValue }) => (
                      <Form onSubmit={handleSubmit}>
                        <TextField 
                          margin="normal"
                          placeholder="Email Id / Mobile No."
                          fullWidth
                          variant="outlined"
                          size={isMobile ? "small" : "medium"}
                          {...getFieldProps('login_id')}
                          error={touched?.login_id && Boolean(errors?.login_id)}
                          helperText={touched?.login_id && errors?.login_id}
                          sx={{
                            '& .MuiInputBase-input': {
                              fontSize: isMobile ? '16px' : '14px',
                              padding: isMobile ? '12px 14px' : '16px 14px'
                            }
                          }}
                        />

                        <Box sx={{ mt: 2, mb: 1, display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                          <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                            M-Pin
                          </Typography>
                          <Stack direction="row" spacing={2} alignItems="center" justifyContent="flex-start" width="100%">
                            <OtpInput
                              numInputs={4}
                              value={values.password}
                              onChange={(val) => setFieldValue('password', val)}
                              containerStyle={{ gap: '15px', display: 'flex' }}
                              inputStyle={{
                                color: '#001B71',
                                WebkitTextFillColor: 'black !important',
                                padding: '0px',
                                fontWeight: 600,
                                fontSize: '1.25rem',
                                borderRadius: '4px',
                                boxSizing: 'content-box',
                                height: '50px',
                                display: 'block',
                                width: '45px',
                                minWidth: '0px',
                                border: '1px solid #c4c4c4'
                              }}
                              renderInput={(props) => <input {...props} type={showPassword['password'] ? 'text' : 'password'} />}
                            />
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={() => handleClickShowPassword('password')}
                              onMouseDown={handleMouseDownPassword}
                            >
                              {showPassword['password'] ? <VisibilityOff /> : <Visibility />}
                            </IconButton>
                          </Stack>
                          {touched?.password && errors?.password && (
                            <Typography variant="caption" color="error" sx={{ mt: 1 }}>
                              {errors.password}
                            </Typography>
                          )}
                        </Box>

                        <Grid container spacing={2} sx={{ mt: 1 }}>
                          <Grid item xs={12} sm={8} md={6} lg={6} xl={6}>
                            {/* <Button variant="text" sx={{ width: 'fit-content', fontWeight: 600 }} onClick={() => handleLoginOtp('agent', values)}>Login through OTP</Button> */}
                          </Grid>
                          <Grid item xs={12} sm={8} md={6} lg={6} xl={6} justifyContent={'end'} display={'flex'}>
                            <Button endIcon={<ContactSupportIcon />} onClick={() => navigate('/forgetPassword?type=procurement')}>Forgot M-Pin</Button>
                          </Grid>
                        </Grid>

                        <Stack spacing={1} sx={{ mt: 2 }}>
                          <Button type="submit" fullWidth variant="contained" sx={{ mt: 3, mb: 2 }} >{loader?    <Box sx={{ display: 'flex' }}>
      <CircularProgress size={25}/>
    </Box>:'Sign In as PROCUREMENT'}</Button>
                          <Button 
                            fullWidth 
                            variant="outlined" 
                            sx={{ mb: 2 }}
                            onClick={() => navigate('/ProcurementOnboarding/8a67015a-edae-4cac-87c8-eac22f9e1cc0')}
                          >
                            Onboard New Procurement Partner
                          </Button>
                        </Stack>
                        
                      </Form>
                    )}
                  </Formik>
                </Box>
            

            </CustomTabPanel>
            <CustomTabPanel value={value} index={2}>
                
                <Box sx={{ mt: 1 }}>
                  <Formik validationSchema={AdminSchema} onSubmit={handleAdminLogin}
                    initialValues={{ login_id: '', password: "" }} enableReinitialize={true}>
                    {({ handleSubmit, handleChange, values, errors, getFieldProps, touched }) => (
                      <Form onSubmit={handleSubmit}>
                        <TextField margin="normal"
                          placeholder="Email Id / Mobile No."
                          fullWidth
                          variant="outlined"
                          {...getFieldProps('login_id')}
                          error={touched?.login_id && Boolean(errors?.login_id)}
                          helperText={touched?.login_id && errors?.login_id}
                        />

                        <TextField margin="normal"
                          type={showPassword['password'] ? 'text' : 'password'}
                          placeholder="Password"
                          fullWidth
                          variant="outlined"
                          {...getFieldProps('password')}
                          error={touched?.password && Boolean(errors?.password)}
                          helperText={touched?.password && errors?.password}
                          InputProps={{
                            endAdornment:
                              <InputAdornment position="end">
                                <IconButton
                                  aria-label="toggle password visibility"
                                  onClick={() => handleClickShowPassword('password')}
                                  onMouseDown={handleMouseDownPassword}
                                  edge="end"
                                >
                                  {showPassword['password'] ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                              </InputAdornment>
                          }}
                        />

                        <Stack spacing={1} sx={{ mt: 2 }}>
                          <Button type="submit" fullWidth variant="contained" sx={{ mt: 3, mb: 2 }} >{loader?    <Box sx={{ display: 'flex' }}>
      <CircularProgress size={25}/>
    </Box>:'Sign In as PROCUREMENT'}</Button>
                        </Stack>
                        
                      </Form>
                    )}
                  </Formik>
                </Box>
            

            </CustomTabPanel>

              <CustomTabPanel value={value} index={3}>
                <Box sx={{ mt: 1 }}>
                  <Formik validationSchema={AgentSchema} onSubmit={handleAgentLogin}
                    initialValues={{ login_id: sessionStorage.getItem('otpVerify') ? JSON.parse(sessionStorage.getItem('otpVerify')).type === 'agent' ? JSON.parse(sessionStorage.getItem('otpVerify')).login_id : '' : '', password: "" }} enableReinitialize={true}>
                    {({ handleSubmit, handleChange, values, errors, getFieldProps, touched, setFieldValue }) => (
                      <form onSubmit={handleSubmit}>
                        <TextField margin="normal"
                          placeholder="Email Id / Mobile No."
                          fullWidth
                          label=""
                          variant="outlined"
                          {...getFieldProps('login_id')}
                          error={touched?.login_id && Boolean(errors?.login_id)}
                          helperText={touched?.login_id && errors?.login_id}
                        />

                        <Box sx={{ mt: 2, mb: 1, display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                          <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                            M-Pin
                          </Typography>
                          <Stack direction="row" spacing={2} alignItems="center" justifyContent="flex-start" width="100%">
                            <OtpInput
                              numInputs={4}
                              value={values.password}
                              onChange={(val) => setFieldValue('password', val)}
                              containerStyle={{ gap: '15px', display: 'flex' }}
                              inputStyle={{
                                color: '#001B71',
                                WebkitTextFillColor: 'black !important',
                                padding: '0px',
                                fontWeight: 600,
                                fontSize: '1.25rem',
                                borderRadius: '4px',
                                boxSizing: 'content-box',
                                height: '50px',
                                display: 'block',
                                width: '45px',
                                minWidth: '0px',
                                border: '1px solid #c4c4c4'
                              }}
                              renderInput={(props) => <input {...props} type={showPassword['reenter_password'] ? 'text' : 'password'} />}
                            />
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={() => handleClickShowPassword('reenter_password')}
                              onMouseDown={handleMouseDownPassword}
                            >
                              {showPassword['reenter_password'] ? <VisibilityOff /> : <Visibility />}
                            </IconButton>
                          </Stack>
                          {touched?.password && errors?.password && (
                            <Typography variant="caption" color="error" sx={{ mt: 1 }}>
                              {errors.password}
                            </Typography>
                          )}
                        </Box>

                        <Grid container spacing={2} sx={{ mt: 1 }}>
                          <Grid item xs={12} sm={8} md={6} lg={6} xl={6}>
                            <Button variant="text" sx={{ width: 'fit-content', fontWeight: 600 }} onClick={() => handleLoginOtp('agent', values)}>Login through OTP</Button>
                          </Grid>
                          <Grid item xs={12} sm={8} md={6} lg={6} xl={6} justifyContent={'end'} display={'flex'}>
                            <Button endIcon={<ContactSupportIcon />} onClick={() => navigate('/forgetPassword')}>Forgot M-Pin</Button>
                          </Grid>
                        </Grid>

                        <Stack spacing={2} direction={'row'} sx={{ mt: 2 }}>
                          <Button type="submit" fullWidth variant="contained" sx={{ mt: 3, mb: 2 }} >{loader?     <Box sx={{ display: 'flex' }}>
      <CircularProgress size={25} />
    </Box>:'Sign In as ASSOCIATE'}</Button>
                        </Stack>
                      </form>
                    )}
                  </Formik>
                </Box>
              </CustomTabPanel>
            </Box>

            <Typography variant="caption" color="text.secondary" align="center" sx={{ mt: 3, px: 3 }}>
              By signing in, you agree to our{' '}
              <Link href="/terms-and-conditions" target="_blank" rel="noopener noreferrer">Terms &amp; Conditions</Link>
              {' '}and{' '}
              <Link href="/refund-policy" target="_blank" rel="noopener noreferrer">Refund &amp; Cancellation Policy</Link>.
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </ThemeProvider>
  );
}


